import { InterestPostingPolicy, PdfTemplate } from '../__generated__/graphql/api';

export const PDF_TEMPLATE_LABELS: Record<PdfTemplate, string> = {
  [PdfTemplate.StatementHomelight]: 'HomeLight statement',
  [PdfTemplate.StatementLfcu]: 'LFCU statement',
  [PdfTemplate.StatementCardGeneric]: 'Generic card statement (Pesto brand)',
};

export const PDF_TEMPLATES_BY_POLICY: Record<InterestPostingPolicy, readonly PdfTemplate[]> = {
  [InterestPostingPolicy.TrailingNextStatement]: [PdfTemplate.StatementHomelight],
  [InterestPostingPolicy.SameCycleStatementClose]: [PdfTemplate.StatementLfcu, PdfTemplate.StatementCardGeneric],
};

export const toPdfTemplateOptions = (templates: readonly PdfTemplate[]) =>
  templates.map((template) => ({ value: template, label: PDF_TEMPLATE_LABELS[template] }));
